import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import IsApprovedStatusIcon from '../../../../../../../../components/IsApprovedStatusIcon';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    lastReviewIsApproved?: ?boolean;
}

export class TimesheetEntryLastReviewIsApproved extends React.PureComponent<Props> {
    render() {
        const { lastReviewIsApproved } = this.props;
        return <IsApprovedStatusIcon isApproved={lastReviewIsApproved} />;
    }
}

const mapStateToProps = createStructuredSelector({
    lastReviewIsApproved: makeSelectTimesheetEntryValue('lastReviewIsApproved')
});

export default connect(mapStateToProps)(TimesheetEntryLastReviewIsApproved);
